function FlagIcon() {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7904 1L6.1237 5.66667L1.45703 1"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Logo() {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4237 52.0079C10.9288 52.0079 10.5019 51.8987 10.143 51.6802C9.78626 51.4595 9.51094 51.1519 9.31698 50.7573C9.12526 50.3604 9.02939 49.899 9.02939 49.3728C9.02939 48.8467 9.12526 48.383 9.31698 47.9817C9.51094 47.5782 9.78069 47.2639 10.1262 47.0387C10.474 46.8113 10.8798 46.6976 11.3435 46.6976C11.611 46.6976 11.8752 46.7422 12.136 46.8314C12.3968 46.9205 12.6343 47.0654 12.8483 47.2661C13.0623 47.4645 13.2329 47.7276 13.3599 48.0553C13.487 48.383 13.5505 48.7865 13.5505 49.2658V49.6002H9.59119V48.918H12.748C12.748 48.6282 12.69 48.3696 12.5741 48.1422C12.4604 47.9148 12.2976 47.7354 12.0858 47.6038C11.8763 47.4723 11.6288 47.4065 11.3435 47.4065C11.0291 47.4065 10.7571 47.4846 10.5275 47.6406C10.3001 47.7944 10.1251 47.9951 10.0025 48.2425C9.87989 48.49 9.81859 48.7553 9.81859 49.0384V49.4932C9.81859 49.8811 9.88547 50.21 10.0192 50.4797C10.1552 50.7472 10.3436 50.9512 10.5844 51.0917C10.8251 51.2299 11.1049 51.299 11.4237 51.299C11.6311 51.299 11.8183 51.27 11.9855 51.2121C12.155 51.1519 12.301 51.0627 12.4236 50.9445C12.5462 50.8241 12.641 50.6748 12.7078 50.4964L13.4703 50.7104C13.39 50.9691 13.2551 51.1964 13.0657 51.3926C12.8762 51.5866 12.6421 51.7382 12.3634 51.8474C12.0847 51.9544 11.7715 52.0079 11.4237 52.0079ZM16.8377 52.0079C16.3562 52.0079 15.9415 51.8942 15.5937 51.6668C15.246 51.4394 14.9784 51.1262 14.7912 50.7272C14.6039 50.3281 14.5103 49.8722 14.5103 49.3595C14.5103 48.8378 14.6061 48.3774 14.7979 47.9784C14.9918 47.5771 15.2616 47.2639 15.6071 47.0387C15.9549 46.8113 16.3606 46.6976 16.8244 46.6976C17.1855 46.6976 17.511 46.7645 17.8008 46.8982C18.0906 47.032 18.3281 47.2193 18.5131 47.46C18.6981 47.7008 18.8129 47.9817 18.8575 48.3027H18.0683C18.0081 48.0687 17.8744 47.8613 17.6671 47.6807C17.4619 47.4979 17.1855 47.4065 16.8377 47.4065C16.5301 47.4065 16.2603 47.4868 16.0285 47.6473C15.7988 47.8056 15.6194 48.0296 15.4901 48.3195C15.363 48.607 15.2995 48.9448 15.2995 49.3327C15.2995 49.7295 15.3619 50.0751 15.4867 50.3694C15.6138 50.6636 15.7922 50.8921 16.0218 51.0549C16.2536 51.2176 16.5256 51.299 16.8377 51.299C17.0428 51.299 17.229 51.2633 17.3962 51.192C17.5634 51.1206 17.7049 51.0181 17.8209 50.8843C17.9368 50.7506 18.0193 50.5901 18.0683 50.4028H18.8575C18.8129 50.706 18.7026 50.9791 18.5265 51.2221C18.3526 51.4629 18.1218 51.6546 17.8343 51.7973C17.5489 51.9377 17.2167 52.0079 16.8377 52.0079ZM22.1648 52.0079C21.6699 52.0079 21.2429 51.8987 20.884 51.6802C20.5273 51.4595 20.252 51.1519 20.058 50.7573C19.8663 50.3604 19.7705 49.899 19.7705 49.3728C19.7705 48.8467 19.8663 48.383 20.058 47.9817C20.252 47.5782 20.5217 47.2639 20.8673 47.0387C21.2151 46.8113 21.6208 46.6976 22.0845 46.6976C22.3521 46.6976 22.6162 46.7422 22.8771 46.8314C23.1379 46.9205 23.3753 47.0654 23.5893 47.2661C23.8034 47.4645 23.9739 47.7276 24.101 48.0553C24.2281 48.383 24.2916 48.7865 24.2916 49.2658V49.6002H20.3323V48.918H23.489C23.489 48.6282 23.4311 48.3696 23.3151 48.1422C23.2014 47.9148 23.0387 47.7354 22.8269 47.6038C22.6173 47.4723 22.3699 47.4065 22.0845 47.4065C21.7702 47.4065 21.4982 47.4846 21.2686 47.6406C21.0412 47.7944 20.8662 47.9951 20.7436 48.2425C20.621 48.49 20.5596 48.7553 20.5596 49.0384V49.4932C20.5596 49.8811 20.6265 50.21 20.7603 50.4797C20.8963 50.7472 21.0847 50.9512 21.3254 51.0917C21.5662 51.2299 21.846 51.299 22.1648 51.299C22.3721 51.299 22.5594 51.27 22.7266 51.2121C22.896 51.1519 23.042 51.0627 23.1647 50.9445C23.2873 50.8241 23.382 50.6748 23.4489 50.4964L24.2113 50.7104C24.1311 50.9691 23.9962 51.1964 23.8067 51.3926C23.6172 51.5866 23.3831 51.7382 23.1045 51.8474C22.8258 51.9544 22.5126 52.0079 22.1648 52.0079ZM26.2813 48.811V51.9009H25.4921V46.7645H26.2545V47.567H26.3214C26.4418 47.3062 26.6246 47.0967 26.8699 46.9384C27.1151 46.7779 27.4316 46.6976 27.8196 46.6976C28.1673 46.6976 28.4716 46.7689 28.7325 46.9116C28.9933 47.0521 29.1962 47.2661 29.3411 47.5537C29.486 47.839 29.5585 48.2002 29.5585 48.6371V51.9009H28.7693V48.6906C28.7693 48.2871 28.6645 47.9728 28.4549 47.7476C28.2454 47.5202 27.9578 47.4065 27.5922 47.4065C27.3402 47.4065 27.1151 47.4612 26.9167 47.5704C26.7205 47.6796 26.5655 47.839 26.4518 48.0486C26.3381 48.2581 26.2813 48.5123 26.2813 48.811ZM33.2344 46.7645V47.4333H30.5725V46.7645H33.2344ZM31.3484 45.5339H32.1375V50.4295C32.1375 50.6525 32.1699 50.8197 32.2345 50.9312C32.3014 51.0404 32.3861 51.114 32.4887 51.1519C32.5935 51.1875 32.7038 51.2054 32.8197 51.2054C32.9067 51.2054 32.978 51.2009 33.0338 51.192C33.0895 51.1808 33.1341 51.1719 33.1675 51.1652L33.328 51.8742C33.2745 51.8942 33.1998 51.9143 33.104 51.9344C33.0081 51.9567 32.8866 51.9678 32.7395 51.9678C32.5165 51.9678 32.2981 51.9199 32.084 51.824C31.8723 51.7281 31.6961 51.5821 31.5557 51.3859C31.4175 51.1898 31.3484 50.9423 31.3484 50.6436V45.5339Z"
        fill="#009819"
      />
      <path
        d="M44.0053 52.0079C43.5416 52.0079 43.1347 51.8976 42.7847 51.6769C42.4369 51.4562 42.1649 51.1474 41.9688 50.7506C41.7748 50.3537 41.6778 49.89 41.6778 49.3595C41.6778 48.8244 41.7748 48.3574 41.9688 47.9583C42.1649 47.5592 42.4369 47.2494 42.7847 47.0287C43.1347 46.808 43.5416 46.6976 44.0053 46.6976C44.469 46.6976 44.8747 46.808 45.2225 47.0287C45.5725 47.2494 45.8445 47.5592 46.0385 47.9583C46.2346 48.3574 46.3327 48.8244 46.3327 49.3595C46.3327 49.89 46.2346 50.3537 46.0385 50.7506C45.8445 51.1474 45.5725 51.4562 45.2225 51.6769C44.8747 51.8976 44.469 52.0079 44.0053 52.0079ZM44.0053 51.299C44.3575 51.299 44.6473 51.2087 44.8747 51.0281C45.1021 50.8476 45.2704 50.6101 45.3797 50.3158C45.4889 50.0216 45.5435 49.7028 45.5435 49.3595C45.5435 49.0161 45.4889 48.6962 45.3797 48.3997C45.2704 48.1032 45.1021 47.8636 44.8747 47.6807C44.6473 47.4979 44.3575 47.4065 44.0053 47.4065C43.653 47.4065 43.3632 47.4979 43.1358 47.6807C42.9084 47.8636 42.7401 48.1032 42.6309 48.3997C42.5216 48.6962 42.467 49.0161 42.467 49.3595C42.467 49.7028 42.5216 50.0216 42.6309 50.3158C42.7401 50.6101 42.9084 50.8476 43.1358 51.0281C43.3632 51.2087 43.653 51.299 44.0053 51.299ZM48.3266 48.811V51.9009H47.5374V46.7645H48.2999V47.567H48.3667C48.4871 47.3062 48.6699 47.0967 48.9152 46.9384C49.1604 46.7779 49.477 46.6976 49.8649 46.6976C50.2127 46.6976 50.517 46.7689 50.7778 46.9116C51.0386 47.0521 51.2415 47.2661 51.3864 47.5537C51.5313 47.839 51.6038 48.2002 51.6038 48.6371V51.9009H50.8146V48.6906C50.8146 48.2871 50.7098 47.9728 50.5002 47.7476C50.2907 47.5202 50.0031 47.4065 49.6375 47.4065C49.3856 47.4065 49.1604 47.4612 48.962 47.5704C48.7658 47.6796 48.6109 47.839 48.4972 48.0486C48.3835 48.2581 48.3266 48.5123 48.3266 48.811ZM55.1995 52.0079C54.7045 52.0079 54.2776 51.8987 53.9187 51.6802C53.562 51.4595 53.2867 51.1519 53.0927 50.7573C52.901 50.3604 52.8051 49.899 52.8051 49.3728C52.8051 48.8467 52.901 48.383 53.0927 47.9817C53.2867 47.5782 53.5564 47.2639 53.902 47.0387C54.2498 46.8113 54.6555 46.6976 55.1192 46.6976C55.3867 46.6976 55.6509 46.7422 55.9117 46.8314C56.1726 46.9205 56.41 47.0654 56.624 47.2661C56.838 47.4645 57.0086 47.7276 57.1357 48.0553C57.2627 48.383 57.3263 48.7865 57.3263 49.2658V49.6002H53.3669V48.918H56.5237C56.5237 48.6282 56.4657 48.3696 56.3498 48.1422C56.2361 47.9148 56.0734 47.7354 55.8616 47.6038C55.652 47.4723 55.4046 47.4065 55.1192 47.4065C54.8049 47.4065 54.5329 47.4846 54.3033 47.6406C54.0759 47.7944 53.9009 47.9951 53.7782 48.2425C53.6556 48.49 53.5943 48.7553 53.5943 49.0384V49.4932C53.5943 49.8811 53.6612 50.21 53.795 50.4797C53.931 50.7472 54.1193 50.9512 54.3601 51.0917C54.6009 51.2299 54.8807 51.299 55.1995 51.299C55.4068 51.299 55.5941 51.27 55.7613 51.2121C55.9307 51.1519 56.0767 51.0627 56.1993 50.9445C56.3219 50.8241 56.4167 50.6748 56.4836 50.4964L57.246 50.7104C57.1658 50.9691 57.0309 51.1964 56.8414 51.3926C56.6519 51.5866 56.4178 51.7382 56.1391 51.8474C55.8605 51.9544 55.5472 52.0079 55.1995 52.0079ZM62.1651 47.9148L61.4562 48.1155C61.4116 47.9973 61.3458 47.8825 61.2589 47.771C61.1741 47.6573 61.0582 47.5637 60.9111 47.4901C60.7639 47.4166 60.5756 47.3798 60.3459 47.3798C60.0316 47.3798 59.7696 47.4522 59.5601 47.5971C59.3528 47.7398 59.2491 47.9215 59.2491 48.1422C59.2491 48.3384 59.3204 48.4933 59.4631 48.607C59.6058 48.7207 59.8287 48.8155 60.1319 48.8913L60.8944 49.0786C61.3536 49.19 61.6958 49.3606 61.921 49.5902C62.1461 49.8176 62.2587 50.1107 62.2587 50.4697C62.2587 50.764 62.174 51.027 62.0046 51.2589C61.8374 51.4907 61.6033 51.6735 61.3023 51.8073C61.0014 51.9411 60.6514 52.0079 60.2523 52.0079C59.7284 52.0079 59.2948 51.8942 58.9515 51.6668C58.6082 51.4394 58.3908 51.1073 58.2994 50.6703L59.0484 50.4831C59.1198 50.7595 59.2547 50.9668 59.4531 51.105C59.6537 51.2433 59.9157 51.3124 60.2389 51.3124C60.6068 51.3124 60.8988 51.2343 61.1151 51.0783C61.3335 50.92 61.4428 50.7305 61.4428 50.5098C61.4428 50.3315 61.3804 50.1821 61.2555 50.0617C61.1307 49.9391 60.9389 49.8477 60.6803 49.7875L59.8243 49.5868C59.3539 49.4754 59.0083 49.3026 58.7876 49.0685C58.5691 48.8322 58.4599 48.5368 58.4599 48.1824C58.4599 47.8925 58.5413 47.6362 58.704 47.4132C58.869 47.1903 59.093 47.0153 59.3762 46.8882C59.6615 46.7611 59.9848 46.6976 60.3459 46.6976C60.8542 46.6976 61.2533 46.8091 61.5431 47.032C61.8352 47.2549 62.0425 47.5492 62.1651 47.9148ZM65.6805 46.7645V47.4333H63.0187V46.7645H65.6805ZM63.7945 45.5339H64.5837V50.4295C64.5837 50.6525 64.616 50.8197 64.6807 50.9312C64.7475 51.0404 64.8322 51.114 64.9348 51.1519C65.0396 51.1875 65.1499 51.2054 65.2659 51.2054C65.3528 51.2054 65.4241 51.2009 65.4799 51.192C65.5356 51.1808 65.5802 51.1719 65.6136 51.1652L65.7742 51.8742C65.7206 51.8942 65.646 51.9143 65.5501 51.9344C65.4542 51.9567 65.3327 51.9678 65.1856 51.9678C64.9627 51.9678 64.7442 51.9199 64.5302 51.824C64.3184 51.7281 64.1423 51.5821 64.0018 51.3859C63.8636 51.1898 63.7945 50.9423 63.7945 50.6436V45.5339Z"
        fill="#009819"
      />
      <path
        d="M5.35877 51.9009H3.24534V45.0523H5.4524C6.11675 45.0523 6.68524 45.1894 7.15787 45.4636C7.63049 45.7356 7.99276 46.1269 8.24468 46.6374C8.4966 47.1457 8.62256 47.7543 8.62256 48.4633C8.62256 49.1766 8.49548 49.7908 8.24133 50.3058C7.98719 50.8186 7.61711 51.2132 7.13111 51.4896C6.64511 51.7638 6.05433 51.9009 5.35877 51.9009ZM4.07466 51.1652H5.30527C5.87152 51.1652 6.3408 51.056 6.71311 50.8375C7.08541 50.619 7.36297 50.308 7.54577 49.9045C7.72858 49.501 7.81999 49.0206 7.81999 48.4633C7.81999 47.9104 7.7297 47.4344 7.54912 47.0353C7.36854 46.6341 7.09879 46.3264 6.73986 46.1124C6.38093 45.8961 5.93395 45.788 5.3989 45.788H4.07466V51.1652Z"
        fill="#009819"
      />
      <path
        d="M35.6135 51.9009V45.0523H36.4428V48.1021H40.0945V45.0523H40.9238V51.9009H40.0945V48.8378H36.4428V51.9009H35.6135Z"
        fill="#009819"
      />
      <path
        d="M15.7838 58.5436V56.0971H14.819V55.5285H17.4464V56.0971H16.4816V58.5436H15.7838ZM17.8219 58.5436V55.5285H19.127C19.3969 55.5285 19.6295 55.573 19.8248 55.6621C20.02 55.7482 20.1708 55.8731 20.277 56.0368C20.3833 56.2005 20.4364 56.3957 20.4364 56.6226C20.4364 56.8466 20.3833 57.0404 20.277 57.2041C20.1708 57.3649 20.02 57.4884 19.8248 57.5745C19.6295 57.6606 19.3969 57.7037 19.127 57.7037H18.2095L18.5197 57.3979V58.5436H17.8219ZM19.7386 58.5436L18.9848 57.4496H19.73L20.4924 58.5436H19.7386ZM18.5197 57.4754L18.2095 57.1481H19.0882C19.3036 57.1481 19.4644 57.1021 19.5706 57.0102C19.6769 56.9155 19.73 56.7863 19.73 56.6226C19.73 56.456 19.6769 56.3268 19.5706 56.2349C19.4644 56.143 19.3036 56.0971 19.0882 56.0971H18.2095L18.5197 55.7654V57.4754ZM20.593 58.5436L21.9368 55.5285H22.626L23.9742 58.5436H23.242L22.1393 55.8817H22.415L21.308 58.5436H20.593ZM21.2649 57.8975L21.4501 57.3678H23.0007L23.1903 57.8975H21.2649ZM25.0275 58.5436L23.7267 55.5285H24.4805L25.6176 58.1991H25.1739L26.3283 55.5285H27.0218L25.7167 58.5436H25.0275ZM27.9153 56.7432H29.3668V57.2859H27.9153V56.7432ZM27.967 57.9837H29.6081V58.5436H27.2735V55.5285H29.5521V56.0885H27.967V57.9837ZM30.1633 58.5436V55.5285H30.861V57.9751H32.3729V58.5436H30.1633Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.1617 39.0976C46.3782 38.8581 48.26 37.8436 49.1622 35.4311C49.8629 33.5573 49.6319 31.1215 49.0786 29.2332C48.1578 26.0902 45.7889 22.2499 43.2282 20.6613C44.5075 22.4442 44.9346 22.747 46.0542 24.9666C47.5507 27.9333 49.0262 33.2133 46.3526 35.8543C45.7602 36.4395 45.0098 36.8576 43.9724 37.0549C43.3068 37.1816 42.3649 37.4227 41.4508 37.6616C41.0973 37.7473 40.7462 37.8396 40.3988 37.9367L40.396 37.9374L40.3959 37.9375C38.7608 38.3944 37.2079 38.9563 35.8806 39.421C33.0175 40.4233 30.2417 41.6331 26.6059 41.1976C21.6858 40.6082 19.504 38.4589 18.5078 38.1412C18.9228 38.9024 20.5587 40.2614 21.443 40.872C22.4892 41.5943 23.8236 42.307 25.2446 42.7289C32.2255 44.801 36.1594 40.8413 43.169 39.2501C43.4867 39.1779 43.844 39.2025 44.1617 39.0976Z"
        fill="#009819"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.687 20.8368L37.6867 20.9175C37.6853 21.4994 37.642 22.2353 38.169 22.3418C38.7169 21.4189 38.9646 19.429 39.4598 18.3389C39.7742 18.4326 41.0186 19.4365 41.4467 19.7186C41.4273 20.7577 41.2733 21.177 41.7186 21.5497C41.984 21.3065 42.1715 20.5872 42.2795 20.1703L42.8601 20.2444C42.8047 19.9589 42.7399 19.9487 42.7335 19.7544C42.972 19.6228 43.8649 19.1014 43.9584 18.9064C43.5621 18.6513 43.3611 18.7158 42.8122 18.863C42.2864 19.0042 42.2362 19.1639 41.8322 18.7906L40.2983 17.3893C41.0463 16.8909 43.496 15.7896 43.9846 15.2705C43.6933 14.6863 42.5049 15.0938 41.9263 15.2339C41.1978 15.4102 40.4913 15.5624 39.7828 15.752C38.6745 16.0485 39.0044 16.0599 37.9226 15.2724C37.4721 14.9445 36.8848 14.4534 36.3781 14.157C35.5095 13.6489 34.8604 14.363 35.4864 15.1308L36.8777 16.4C37.6176 17.125 37.8312 16.7524 37.7594 18.1786C37.7156 19.05 37.6892 19.9592 37.687 20.8368Z"
        fill="#009819"
      />
      <path
        d="M28.2423 14.8435C28.2423 14.5888 28.1028 14.3823 27.9307 14.3823C27.7586 14.3823 27.6191 14.5888 27.6191 14.8435C27.6191 15.0982 27.7586 15.3047 27.9307 15.3047C28.1028 15.3047 28.2423 15.0982 28.2423 14.8435Z"
        fill="#009819"
      />
      <path
        d="M27.9887 15.0691H27.874V15.916H27.9887V15.0691Z"
        fill="#009819"
      />
      <path
        d="M28.2423 16.1894C28.2423 15.9347 28.1028 15.7282 27.9307 15.7282C27.7586 15.7282 27.6191 15.9347 27.6191 16.1894C27.6191 16.4441 27.7586 16.6505 27.9307 16.6505C28.1028 16.6505 28.2423 16.4441 28.2423 16.1894Z"
        fill="#009819"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5535 16.3583L27.6998 15.9917L28.2416 16.0106L29.292 16.3489L29.1869 16.4493L28.8694 16.4703L28.8764 16.8135L28.8088 16.9839L28.8127 18.3014L28.868 18.5332L28.5961 19.0844L28.5461 27.2342L28.913 27.7629L28.912 28.9048L29.6236 29.3751L29.1516 29.4292L29.0647 30.8197L27.6309 30.4404L26.6861 30.0843L26.6754 29.4046L26.2021 29.3868L26.9423 28.9136L26.941 27.6708L27.3018 27.3704L27.2888 19.4399L26.9856 18.5629L26.9894 16.8224L26.9681 16.4592C26.7199 16.493 26.6079 16.4433 26.5535 16.3583Z"
        fill="#009819"
      />
      <path
        d="M27.5642 16.9678L27.167 17.1252V18.1162L27.5642 17.9587V16.9678Z"
        fill="#FEFEFE"
      />
      <path
        d="M28.3001 16.9678L28.6973 17.1252V18.1162L28.3001 17.9587V16.9678Z"
        fill="#FEFEFE"
      />
      <path
        d="M28.1369 16.9677H27.7295V17.9933H28.1369V16.9677Z"
        fill="#FEFEFE"
      />
      <path
        d="M27.6828 19.4352L27.4131 19.5789V20.4838L27.6828 20.3401V19.4352Z"
        fill="#FEFEFE"
      />
      <path
        d="M28.1824 19.4352L28.4521 19.5789V20.4838L28.1824 20.3401V19.4352Z"
        fill="#FEFEFE"
      />
      <path
        d="M28.0716 19.435H27.7949V20.3715H28.0716V19.435Z"
        fill="#FEFEFE"
      />
      <path
        d="M27.5642 27.499L27.167 27.6664V28.7199L27.5642 28.5525V27.499Z"
        fill="#FEFEFE"
      />
      <path
        d="M28.3001 27.499L28.6973 27.6664V28.7199L28.3001 28.5525V27.499Z"
        fill="#FEFEFE"
      />
      <path
        d="M28.1369 27.499H27.7295V28.5893H28.1369V27.499Z"
        fill="#FEFEFE"
      />
      <path
        d="M27.5642 29.3489L27.167 29.5163V30.5698L27.5642 30.4025V29.3489Z"
        fill="#FEFEFE"
      />
      <path
        d="M28.3001 29.3489L28.6973 29.5163V30.5698L28.3001 30.4025V29.3489Z"
        fill="#FEFEFE"
      />
      <path
        d="M28.1369 29.3489H27.7295V30.4392H28.1369V29.3489Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.6027 10.3839C32.7274 10.3839 32.8294 10.4859 32.8294 10.6106V11.0802H32.752V10.9567C32.752 10.872 32.6828 10.8027 32.598 10.8027C32.5133 10.8027 32.444 10.872 32.444 10.9567V11.0802H32.376V10.6106C32.376 10.4859 32.478 10.3839 32.6027 10.3839Z"
        fill="#009819"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7476 11.3905C32.9387 11.5037 33.0778 11.814 33.0778 12.0253V13.3263H33.0732V13.3264C33.0052 13.3264 32.9495 13.3821 32.9495 13.4501H32.2468C32.2468 13.3821 32.1911 13.3264 32.123 13.3264V13.3263V12.0253C32.123 11.814 32.2621 11.5037 32.4532 11.3905V11.3067C32.4532 11.2532 32.4969 11.2095 32.5504 11.2095H32.6505C32.7039 11.2095 32.7476 11.2532 32.7476 11.3067V11.3905Z"
        fill="#009819"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.8975 13.792H33.3028L33.2209 13.6319H33.0163C32.9765 13.6169 32.948 13.5785 32.948 13.5336H32.2863C32.2863 13.5785 32.2578 13.6169 32.218 13.6319H31.997L31.8975 13.792Z"
        fill="#009819"
      />
      <path
        d="M33.1247 13.792H32.0693V15.1594H33.1247V13.792Z"
        fill="#009819"
      />
      <path
        d="M32.6649 14.4756C32.6649 14.1831 32.6344 13.9461 32.5966 13.9461C32.5589 13.9461 32.5283 14.1831 32.5283 14.4756C32.5283 14.768 32.5589 15.005 32.5966 15.005C32.6344 15.005 32.6649 14.768 32.6649 14.4756Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.4412 15.1474H31.752V15.9797H33.4412V15.1474Z"
        fill="#009819"
      />
      <path
        d="M32.0844 15.2437H31.8232V15.8857H32.0844V15.2437Z"
        fill="#FEFEFE"
      />
      <path
        d="M32.516 15.2437H32.2549V15.8857H32.516V15.2437Z"
        fill="#FEFEFE"
      />
      <path
        d="M32.9467 15.2437H32.6855V15.8857H32.9467V15.2437Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.3783 15.2437H33.1172V15.8857H33.3783V15.2437Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.6211 15.8922H33.5388L33.4421 16.7245H31.7528L31.6211 15.8922Z"
        fill="#009819"
      />
      <path
        d="M32.2558 16.3439C32.2558 16.2162 32.2252 16.1127 32.1874 16.1127C32.1497 16.1127 32.1191 16.2162 32.1191 16.3439C32.1191 16.4717 32.1497 16.5752 32.1874 16.5752C32.2252 16.5752 32.2558 16.4717 32.2558 16.3439Z"
        fill="#FEFEFE"
      />
      <path
        d="M32.6474 16.3439C32.6474 16.2162 32.6168 16.1126 32.5791 16.1126C32.5413 16.1126 32.5107 16.2162 32.5107 16.3439C32.5107 16.4717 32.5413 16.5752 32.5791 16.5752C32.6168 16.5752 32.6474 16.4717 32.6474 16.3439Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.039 16.3439C33.039 16.2162 33.0084 16.1126 32.9706 16.1126C32.9329 16.1126 32.9023 16.2162 32.9023 16.3439C32.9023 16.4717 32.9329 16.5752 32.9706 16.5752C33.0084 16.5752 33.039 16.4717 33.039 16.3439Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.3185 16.6904H31.8975V20.3365H33.3185V16.6904Z"
        fill="#009819"
      />
      <path
        d="M32.2743 18.6162C32.2743 18.3001 32.2437 18.0439 32.206 18.0439C32.1683 18.0439 32.1377 18.3001 32.1377 18.6162C32.1377 18.9322 32.1683 19.1885 32.206 19.1885C32.2437 19.1885 32.2743 18.9322 32.2743 18.6162Z"
        fill="#FEFEFE"
      />
      <path
        d="M32.6688 18.6162C32.6688 18.3001 32.6383 18.0439 32.6005 18.0439C32.5628 18.0439 32.5322 18.3001 32.5322 18.6162C32.5322 18.9322 32.5628 19.1885 32.6005 19.1885C32.6383 19.1885 32.6688 18.9322 32.6688 18.6162Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.0692 18.6162C33.0692 18.3001 33.0387 18.0439 33.0009 18.0439C32.9632 18.0439 32.9326 18.3001 32.9326 18.6162C32.9326 18.9322 32.9632 19.1885 33.0009 19.1885C33.0387 19.1885 33.0692 18.9322 33.0692 18.6162Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.6514 20.3332H31.5752V21.3561H33.6514V20.3332Z"
        fill="#009819"
      />
      <path
        d="M31.983 20.4515H31.6621V21.2407H31.983V20.4515Z"
        fill="#FEFEFE"
      />
      <path
        d="M32.5133 20.4515H32.1924V21.2407H32.5133V20.4515Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.0426 20.4515H32.7217V21.2407H33.0426V20.4515Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.5729 20.4515H33.252V21.2407H33.5729V20.4515Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.4609 21.3544H33.7658L33.4582 22.1867H31.7383L31.4609 21.3544Z"
        fill="#009819"
      />
      <path
        d="M33.4602 22.1777H31.7393V26.6367H33.4602V22.1777Z"
        fill="#009819"
      />
      <path
        d="M33.999 26.6363H31.2451V27.9931H33.999V26.6363Z"
        fill="#009819"
      />
      <path d="M31.786 26.7933H31.3604V27.84H31.786V26.7933Z" fill="#FEFEFE" />
      <path
        d="M32.4892 26.7933H32.0635V27.84H32.4892V26.7933Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.1923 26.7933H32.7666V27.84H33.1923V26.7933Z"
        fill="#FEFEFE"
      />
      <path
        d="M33.8954 26.7933H33.4697V27.84H33.8954V26.7933Z"
        fill="#FEFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.0938 27.9907H34.1509L31.4689 29.3372L31.0938 27.9907Z"
        fill="#009819"
      />
    </svg>
  );
}

function UzbFlag() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.40039 0.399994C3.99159 0.399994 0.400391 3.99119 0.400391 8.39999C0.400391 12.8088 3.99159 16.4 8.40039 16.4C10.3176 16.4 12.0783 15.7192 13.4582 14.5891L18.2348 19.3656C18.3085 19.4424 18.3968 19.5037 18.4945 19.5459C18.5922 19.5882 18.6973 19.6105 18.8038 19.6115C18.9102 19.6126 19.0158 19.5925 19.1143 19.5522C19.2129 19.512 19.3024 19.4525 19.3776 19.3773C19.4529 19.302 19.5124 19.2125 19.5526 19.1139C19.5929 19.0154 19.613 18.9098 19.6119 18.8034C19.6109 18.6969 19.5886 18.5918 19.5463 18.4941C19.5041 18.3964 19.4428 18.3081 19.366 18.2344L14.5895 13.4578C15.7196 12.0779 16.4004 10.3172 16.4004 8.39999C16.4004 3.99119 12.8092 0.399994 8.40039 0.399994ZM8.40039 1.99999C11.9445 1.99999 14.8004 4.8559 14.8004 8.39999C14.8004 11.9441 11.9445 14.8 8.40039 14.8C4.85629 14.8 2.00039 11.9441 2.00039 8.39999C2.00039 4.8559 4.85629 1.99999 8.40039 1.99999Z"
        fill="white"
      />
    </svg>
  );
}

function MapIcon() {
  return (
    <svg
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9521 2.05193C10.6331 0.750899 8.85483 0.0214844 7.00211 0.0214844C5.1494 0.0214844 3.37116 0.750899 2.05211 2.05193C-0.979885 5.08693 0.352115 8.73793 1.62011 11.2209C1.79611 11.5639 1.99311 11.8989 2.19911 12.2259L6.15711 18.5309C6.24711 18.6743 6.37203 18.7925 6.52017 18.8744C6.66831 18.9564 6.83483 18.9993 7.00411 18.9993C7.1734 18.9993 7.33992 18.9564 7.48806 18.8744C7.6362 18.7925 7.76112 18.6743 7.85111 18.5309L11.8511 12.1609C12.0271 11.8779 12.1981 11.5879 12.3511 11.2919C13.6381 8.78793 15.0001 5.09993 11.9521 2.05193ZM10.5681 10.3769C10.4421 10.6239 10.2991 10.8649 10.1521 11.0989L7.00011 16.1199L3.88811 11.1639C3.71411 10.8869 3.54612 10.6039 3.39712 10.3119C1.79212 7.16693 1.81212 5.11893 3.46312 3.46593C4.40733 2.53913 5.67755 2.0199 7.00061 2.0199C8.32368 2.0199 9.5939 2.53913 10.5381 3.46593C12.2001 5.12893 12.2091 7.19993 10.5681 10.3769Z"
        fill="black"
      />
      <path
        d="M7 4C6.40666 4 5.82664 4.17595 5.33329 4.50559C4.83994 4.83524 4.45543 5.30377 4.22836 5.85195C4.0013 6.40013 3.94189 7.00333 4.05765 7.58527C4.1734 8.16721 4.45912 8.70176 4.87868 9.12132C5.29824 9.54088 5.83279 9.8266 6.41473 9.94236C6.99667 10.0581 7.59987 9.9987 8.14805 9.77164C8.69623 9.54458 9.16477 9.16006 9.49441 8.66671C9.82405 8.17336 10 7.59334 10 7C10 6.20435 9.68393 5.44129 9.12132 4.87868C8.55871 4.31607 7.79565 4 7 4ZM7 8C6.80222 8 6.60888 7.94135 6.44443 7.83147C6.27998 7.72159 6.15181 7.56541 6.07612 7.38268C6.00043 7.19996 5.98063 6.99889 6.01922 6.80491C6.0578 6.61093 6.15304 6.43275 6.2929 6.29289C6.43275 6.15304 6.61093 6.0578 6.80491 6.01921C6.99889 5.98063 7.19996 6.00043 7.38269 6.07612C7.56541 6.15181 7.72159 6.27998 7.83147 6.44443C7.94135 6.60888 8 6.80222 8 7C8 7.26522 7.89464 7.51957 7.70711 7.70711C7.51957 7.89464 7.26522 8 7 8Z"
        fill="black"
      />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1909 15.489L22.1529 14.662L15.6699 13.736L14.3549 16.31C12.9665 15.5283 11.6973 14.5517 10.5859 13.41C9.4315 12.3004 8.44782 11.0259 7.66691 9.62801L10.4669 8.22801L7.66691 1.70801L6.90691 1.81801C5.61977 1.99531 4.42729 2.59296 3.51491 3.51801C0.341909 6.68701 1.58491 12.9 6.34291 17.657C9.32491 20.638 12.8759 22.239 15.8939 22.238C16.7375 22.2674 17.5784 22.1274 18.3669 21.8263C19.1554 21.5252 19.8756 21.0691 20.4849 20.485C21.1073 19.8208 21.5813 19.0319 21.8754 18.1705C22.1695 17.3092 22.2771 16.3951 22.1909 15.489ZM19.0709 19.071C16.7709 21.371 11.5899 20.071 7.75691 16.243C3.92391 12.415 2.62891 7.22901 4.92891 4.92901C5.35765 4.49451 5.88239 4.16672 6.46091 3.97201L7.88091 7.28501L6.77391 7.83801C6.53411 7.95811 6.32077 8.12498 6.14646 8.3288C5.97215 8.53262 5.84039 8.76926 5.75894 9.02478C5.6775 9.28031 5.64801 9.54955 5.67222 9.81664C5.69643 10.0837 5.77384 10.3433 5.89991 10.58C6.77526 12.1482 7.87598 13.5794 9.16691 14.828C10.4158 16.1045 11.8413 17.1952 13.3999 18.067C13.6402 18.1974 13.904 18.2785 14.1761 18.3054C14.4481 18.3324 14.7227 18.3047 14.9839 18.224C15.2393 18.1445 15.476 18.014 15.6795 17.8404C15.883 17.6668 16.0491 17.4537 16.1679 17.214L16.8149 15.92L20.1819 16.401C20.1435 17.3954 19.7492 18.3429 19.0709 19.071Z"
        fill="black"
      />
    </svg>
  );
}

function MessengeIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 4V20H22V4H2ZM9.981 13.7L12 15.267L14.019 13.7L19.4 18H4.6L9.981 13.7ZM4 15.919V9.044L8.357 12.433L4 15.919ZM15.643 12.433L20 9.045V15.919L15.643 12.433ZM20 6V6.511L12 12.733L4 6.511V6H20Z"
        fill="black"
      />
    </svg>
  );
}

function FileIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 12H15M9 16H15M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H12.586C12.8512 3.00006 13.1055 3.10545 13.293 3.293L18.707 8.707C18.8946 8.89449 18.9999 9.1488 19 9.414V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Facebook() {
  return (
    <svg
      width="10"
      height="20"
      viewBox="0 0 10 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.14971 3.29509H9.96139V0.139742C9.64884 0.0967442 8.5739 0 7.32201 0C4.70992 0 2.92057 1.643 2.92057 4.66274V7.44186H0.0380859V10.9693H2.92057V19.845H6.45462V10.9701H9.22052L9.65958 7.44269H6.4538V5.01251C6.45462 3.99297 6.72915 3.29509 8.14971 3.29509V3.29509Z"
        fill="#0C111F"
      />
    </svg>
  );
}

function Twitter() {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5556 1.881C18.8283 2.2 18.0534 2.41144 17.2456 2.51411C18.0767 2.01789 18.711 1.23811 19.0092 0.298222C18.2343 0.760222 17.3788 1.08656 16.467 1.26867C15.7312 0.485222 14.6826 0 13.5386 0C11.319 0 9.53211 1.80156 9.53211 4.01011C9.53211 4.32789 9.559 4.63344 9.625 4.92433C6.292 4.76178 3.34278 3.16433 1.36156 0.730889C1.01567 1.331 0.812778 2.01789 0.812778 2.75733C0.812778 4.14578 1.52778 5.37656 2.59356 6.08911C1.94944 6.07689 1.31756 5.88989 0.782222 5.59533C0.782222 5.60756 0.782222 5.62344 0.782222 5.63933C0.782222 7.58756 2.17189 9.20578 3.99422 9.57856C3.66789 9.66778 3.31222 9.71056 2.94311 9.71056C2.68644 9.71056 2.42733 9.69589 2.18411 9.64211C2.70356 11.2298 4.17756 12.397 5.93022 12.4349C4.56622 13.5019 2.83433 14.1448 0.959444 14.1448C0.630667 14.1448 0.315333 14.1301 0 14.0898C1.77589 15.235 3.88056 15.8889 6.15022 15.8889C13.5276 15.8889 17.5609 9.77778 17.5609 4.48067C17.5609 4.30344 17.5548 4.13233 17.5462 3.96244C18.3419 3.39778 19.0104 2.69256 19.5556 1.881Z"
        fill="#0C111F"
      />
    </svg>
  );
}

function Instagram() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 0H13.75C17.2013 0 20 2.79875 20 6.25V13.75C20 17.2013 17.2013 20 13.75 20H6.25C2.79875 20 0 17.2013 0 13.75V6.25C0 2.79875 2.79875 0 6.25 0ZM13.75 18.125C16.1625 18.125 18.125 16.1625 18.125 13.75V6.25C18.125 3.8375 16.1625 1.875 13.75 1.875H6.25C3.8375 1.875 1.875 3.8375 1.875 6.25V13.75C1.875 16.1625 3.8375 18.125 6.25 18.125H13.75Z"
        fill="#0C111F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10C5 7.23875 7.23875 5 10 5C12.7613 5 15 7.23875 15 10C15 12.7613 12.7613 15 10 15C7.23875 15 5 12.7613 5 10ZM6.875 10C6.875 11.7225 8.2775 13.125 10 13.125C11.7225 13.125 13.125 11.7225 13.125 10C13.125 8.27625 11.7225 6.875 10 6.875C8.2775 6.875 6.875 8.27625 6.875 10Z"
        fill="#0C111F"
      />
      <circle cx="15.3752" cy="4.62523" r="0.66625" fill="#0C111F" />
    </svg>
  );
}

function Close() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.59961 1.59998L14.3996 14.4M1.59961 14.4L14.3996 1.59998"
        stroke="black"
        stroke-width="2"
      />
    </svg>
  );
}

function AddIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99974 1.06665V14.9333M1.06641 7.99998H14.9331"
        stroke="black"
        stroke-width="2"
      />
    </svg>
  );
}

function Loc() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6022 5.40269C20.8434 3.66799 18.4725 2.69543 16.0022 2.69543C13.5319 2.69543 11.1609 3.66799 9.40217 5.40269C5.3595 9.44936 7.1355 14.3174 8.82617 17.628C9.06084 18.0854 9.3235 18.532 9.59817 18.968L14.8755 27.3747C14.9955 27.5659 15.1621 27.7235 15.3596 27.8327C15.5571 27.9419 15.7791 27.9992 16.0048 27.9992C16.2306 27.9992 16.4526 27.9419 16.6501 27.8327C16.8476 27.7235 17.0142 27.5659 17.1342 27.3747L22.4675 18.8814C22.7022 18.504 22.9302 18.1174 23.1342 17.7227C24.8502 14.384 26.6662 9.46669 22.6022 5.40269ZM20.7568 16.5027C20.5888 16.832 20.3982 17.1534 20.2022 17.4654L15.9995 24.16L11.8502 17.552C11.6182 17.1827 11.3942 16.8054 11.1955 16.416C9.0555 12.2227 9.08217 9.49203 11.2835 7.28803C12.5425 6.05229 14.2361 5.35999 16.0002 5.35999C17.7643 5.35999 19.4579 6.05229 20.7168 7.28803C22.9328 9.50536 22.9448 12.2667 20.7568 16.5027Z"
        fill="black"
      />
      <path
        d="M16 8C15.2089 8 14.4355 8.2346 13.7777 8.67412C13.1199 9.11365 12.6072 9.73836 12.3045 10.4693C12.0017 11.2002 11.9225 12.0044 12.0769 12.7804C12.2312 13.5563 12.6122 14.269 13.1716 14.8284C13.731 15.3878 14.4437 15.7688 15.2196 15.9231C15.9956 16.0775 16.7998 15.9983 17.5307 15.6955C18.2616 15.3928 18.8864 14.8801 19.3259 14.2223C19.7654 13.5645 20 12.7911 20 12C20 10.9391 19.5786 9.92172 18.8284 9.17157C18.0783 8.42143 17.0609 8 16 8ZM16 13.3333C15.7363 13.3333 15.4785 13.2551 15.2592 13.1086C15.04 12.9621 14.8691 12.7539 14.7682 12.5102C14.6672 12.2666 14.6408 11.9985 14.6923 11.7399C14.7437 11.4812 14.8707 11.2437 15.0572 11.0572C15.2437 10.8707 15.4812 10.7437 15.7399 10.6923C15.9985 10.6408 16.2666 10.6672 16.5102 10.7682C16.7539 10.8691 16.9621 11.04 17.1086 11.2592C17.2551 11.4785 17.3333 11.7363 17.3333 12C17.3333 12.3536 17.1929 12.6928 16.9428 12.9428C16.6928 13.1929 16.3536 13.3333 16 13.3333Z"
        fill="black"
      />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 1024 1024"
      class="menu-btn close"
      height="2em"
      width="4em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
    </svg>
  );
}

export {
  FlagIcon,
  Logo,
  UzbFlag,
  MapIcon,
  PhoneIcon,
  MessengeIcon,
  FileIcon,
  Facebook,
  Twitter,
  Instagram,
  Close,
  AddIcon,
  Loc,
  CloseIcon,
};
